export default __webpack_public_path__ + "static/download-image-2-99f9ddd58ab461c8a364851e548fad10.png";